export enum ReportSummaryColors {
    GREEN = "#8cc9c6",
    GREEN_LIGHT = "#e8f4f4",
    GREEN_FADED = "#B0cdcc",
    ORANGE = "#f5821e",
    ORANGE_LIGHT = "#fde6d2",
    LIGHTBLUE = "#90c2dd",
    BLUE = "#2285bc",
}
